export default __webpack_public_path__ + "static/media/Melissa@2x.af04c22e.png";